<template>
    <div class="summary-box">
      <banner-box />
      <div class="desc-box">
        <div
          v-for="(item, index) in descData"
          class="row"
          :class="{title: item.isTitle}"
          :key="index"
        >
          <span v-if="item.key" class="key">{{item.key}}</span>
          <span v-if="item.value" class="value">{{item.value}}</span>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      descData: [
        { key: '会社紹介', isTitle: true },
        { key: '会社名', value: '双華株式会社' },
        { key: '住所', value: '802-0081　福岡県北九州市小倉北区紺屋町１３番１号毎日西部会館８階' },
        { key: 'TEL', value: '093-967-6640' },
        { key: 'FAX', value: '093-967-6641' },
        { key: 'E-MAIL', value: 'info@sou-ka.jp' },
        { key: '資本金', value: '5000万円' },
        { key: '主な事業内容', value: '木材、合板及び建築用資材の販売並びに輸出入業務' },
        { key: '取扱商品', value: '家具、構造材、合板、建材、ＬＶＬ間柱、集成材、木製DIY商品、吸音パネ儿、原木' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.summary-box{
  display: flex;
  flex-direction: column;

  .desc-box{
    margin-top: 61px;
    margin-bottom: 119px;
    margin-left: 262px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .row{
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 1400px;
      height: 81px;
      border-bottom: 1px solid #d5d2d2;
      position: relative;

      &.title{
        &:before{
          content: '';
          position: absolute;
          top: 28px;
          left: 0px;
          width: 3px;
          height: 17px;
          background: #374475;
        }
        &:after{
          content: '';
          position: absolute;
          top: 45px;
          left: 0px;
          width: 3px;
          height: 17px;
          background: #E29C4F;
        }
        .key{
          font-size: 36px;
        }
      }

      .key{
        width: 225px;
        height: 22px;
        font-family: 04KanjyukuGothic;
        font-weight: 400;
        font-size: 24px;
        color: #374475;
        line-height: 30px;
        margin-left: 17px;
      }

      .value{
        height: 19px;
        font-family: 04KanjyukuGothic;
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        line-height: 30px;
      }
    }
  }
}
</style>
